<template>
  <div class="value-config" @click.stop>
    <div class="value-config-grid">
      <label class="value-field">
        <span class="value-label">Spreadsheet</span>
        <select v-model="config.spreadSheet" class="value-select" @change="onSheetChange">
          <option value="">Select a spreadsheet...</option>
          <option
            v-for="sheet in spreadsheets"
            :key="sheet.uniqueTitle"
            :value="sheet.uniqueTitle"
          >{{ sheet.title || sheet.uniqueTitle }}</option>
        </select>
      </label>

    </div>

    <div v-if="config.spreadSheet" class="value-formula">
      <div class="value-filters-title">Formula</div>
      <p class="value-hint">
        Calculated when the menu loads, over the records that match the filters.
        <span class="value-code">{age}</span> is every value in that column.
        Try COUNT({id}), SUM({qty}), or AVERAGE({age}).
      </p>
      <FormulaEditor
        :model-value="config.formula || ''"
        :columns="formulaColumns"
        :spreadsheets="spreadsheets"
        :current-spreadsheet-unique-title="config.spreadSheet"
        @update:model-value="config.formula = $event"
      />
    </div>

    <label class="value-check">
      <input type="checkbox" v-model="item.requiresLogin" />
      <span>Only show this value when a user is logged in</span>
    </label>

    <label class="value-check">
      <input type="checkbox" v-model="config.scopeToLoggedInUser" />
      <span>When logged in, only records linked to that user</span>
    </label>
    <p class="value-hint">
      Uses the relationship between this spreadsheet and the login spreadsheet.
      <template v-if="!item.requiresLogin">Logged-out visitors still see every record that matches the filters.</template>
    </p>

    <div v-if="config.spreadSheet" class="value-filters">
      <div class="value-filters-title">Filters</div>
      <p class="value-hint">Optional. These are the same filters available on views.</p>
      <PreFilterBuilder
        :filters="config.filters || []"
        :match-mode="config.filterMatchMode || 'all'"
        :spreadsheet="selectedSpreadsheet"
        :all-spreadsheets="spreadsheets"
        :application-unique-title="application"
        @update:filters="config.filters = $event"
        @update:match-mode="config.filterMatchMode = $event"
      />
    </div>
  </div>
</template>

<script>
import PreFilterBuilder from '../lib/PreFilterBuilder.vue'
import FormulaEditor from '../FormulaEditor.vue'

export default {
  name: 'MenuValueConfig',
  components: { PreFilterBuilder, FormulaEditor },
  props: {
    item: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    spreadsheets: {
      type: Array,
      default: () => []
    },
    application: {
      type: String,
      default: ''
    }
  },
  computed: {
    selectedSpreadsheet () {

      return this.spreadsheets.find(sheet => sheet.uniqueTitle === this.config.spreadSheet) || { columns: [], title: '' }
    },
    formulaColumns () {

      const columns = (this.selectedSpreadsheet.columns || []).slice()

      if (!columns.some(column => column.uniqueTitle === 'id')) {

        columns.unshift({ uniqueTitle: 'id', title: 'ID', type: 'number' })
      }

      return columns
    }
  },
  methods: {
    onSheetChange () {

      this.config.formula = 'COUNT({id})'
      this.config.filters = []
      this.config.filterMatchMode = 'all'
    }
  }
}
</script>

<style scoped>
.value-config {
  padding: 4px 12px 12px 36px;
  border-top: 1px solid #2e2e2b;
}

.value-config-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.value-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 180px;
  flex: 1;
}

.value-label,
.value-filters-title {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9ad12b;
}

.value-select {
  background-color: #111;
  border: 1px solid #2e2e2b;
  color: #e8e8e6;
  font-size: 0.8rem;
  padding: 4px 8px;
  border-radius: 3px;
  outline: none;
}

.value-select:focus {
  border-color: #9ad12b;
}

.value-check {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  color: #b0b0ae;
  font-size: 0.8rem;
  cursor: pointer;
}

.value-hint {
  margin: 4px 0 0;
  color: #a8a8a4;
  font-size: 0.72rem;
}

.value-filters,
.value-formula {
  margin-top: 12px;
}

.value-code {
  font-family: monospace;
  color: #b0b0ae;
}
</style>
